var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M6.835 21l3.08-6h12.072l-3.331 6zM15.325 14h6.662L15.325 3H8.662zM2 15l3.331 6 5.663-11-3.332-6z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }